import React, { useState } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import aboutkid from "assets/img/aboutkid.jpeg";
import bgg from "assets/img/bgg.png";
import clock from "assets/img/new/clock.png";
import aboutbanner from "assets/img/new/aboutbanner.jpeg";
import growth from "assets/img/new/way/growth.png";
import creativity from "assets/img/new/way/creativity.png";
import individual from "assets/img/new/way/individual.png";
import leadership from "assets/img/new/way/leadership.png";
import relation from "assets/img/new/way/relation.png";
import location from "assets/img/new/location.png";
import vision from "assets/img/new/way/vision.png";
import mission from "assets/img/new/way/mission.png";
import clouds from "assets/img/clouds.webp";
import bfly1 from "assets/img/bfly1.webp";

export default function OurStory() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <AdminNavbar />
      <section
        className=" xl:-mt-2 lg:mt-0 md:mt-0 mt-18"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "55% auto",
        }}
      >
        <div className="container mx-auto top-0 xl:py-12 lg:py-12 md:py-12">
          <div className=" flex justify-start top-0 xl:pt-12 lg:pt-12 md:pt-12 pt-16 absolute right-0 ">
            <img className="xl:w-44 lg:w-40 md:w-32 w-20" src={clouds} alt="" />
          </div>
          <div className=" flex  absolute left-0 xl:top-64 lg:top-48 md:top-52 top-52 ">
            <img className="xl:w-44 lg:w-44 md:w-32 w-24" src={bfly1} alt="" />
          </div>
          <div className="text-center justify-center xl:w-11/12 lg:w-10/12 md:w-11/12 md:pt-24 xl:pt-28 lg:pt-16 mx-auto pt-8 xl:pb-8 lg:pb-0 md:pb-0 pb-8">
            <h3 class="text-peach font-semibold uppercase xl:text-lg text-lg  bubblegum">
              About Us
            </h3>
            <div className="flex justify-center">
              <h1
                className="text-black xl:text-lg lg:text-lg md:text-base text-sm font-semibold xl:pt-1 xl:w-10/12 "
                style={{ lineHeight: 1.8 }}
              >
                Junior Toes International Preschool is proud to be India’s First
                Entrepreneurial Preschool, dedicated to shaping the future
                leaders of tomorrow. Our innovative early childhood education
                model is built on the research-based Curriculum designed by Award Winning Educationists,
                The Antah Prerana Way of Learning, designed to inspire
                creativity, critical thinking, and leadership in young minds
              </h1>
            </div>

            <a href="#extra-content">
              <button className="xl:w-3/12 rounded text-blue underline font-semibold py-2 xl:mt-4 focus:outline-none focus:ring-0">
                Know More
              </button>
            </a>

            <div
              className="bg-white w-12 h-12 mx-auto items-center xl:mt-4 justify-center flex rounded-full"
              style={{ border: "2px solid #2d86a4" }}
            >
              <a href="#extra-content">
                <i className="las la-arrow-down text-3xl text-blue"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <div
        id="extra-content"
        className="container mx-auto xl:py-12 lg:py-12 md:py-12 xl:px-0 lg:px-4 md:px-4 px-4 py-12"
      >
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-9 lg:grid-cols-9 xl:grid-cols-9 gap-4 ">
          <div
            className="xl:col-span-3 lg:col-span-4 md:col-span-4 col-span-1
 justify-start"
          >
            <img
              src={aboutbanner}
              alt="about us"
              className="rounded-lg xl:w-12/12 lg:w-12/12 md:w-12/12 w-12/12 xl:h-0 lg:h-0 md:h-480 "
            ></img>
          </div>
          <div className="xl:col-span-6 lg:col-span-5 md:col-span-5 col-span-1 xl:pl-6 lg:pl-6   xl:pt-20">
            <h6 class="text-peach font-semibold uppercase xl:text-lg text-lg bubblegum">
              Our Story
            </h6>
            <h6
              className=" xl:text-xl lg:text-xl md:text-xl text-xl "
              style={{ fontStyle: "italic" }}
            >
              "Let childhood be a garden of innocence and freedom—where little
              minds bloom into greatness, one step at a time".
            </h6>

            <p
              className="xl:text-lg lg:text-lg md:text-base lg:pt-2 xl:pt-3 pt-2 text-lg"
              style={{ lineHeight: 1.9 }}
            >
              In a world that’s rushing to prepare children for tomorrow, Junior
              Toes was born from a simple belief: every child deserves to grow
              in innocence and freedom. Guided by research, our entrepreneurial
              preschool nurtures foundational skills through playful exploration
              and real-world experiences, setting children on a path to lifelong
              learning and leadership. Here, little feet take confident steps
              toward big dreams, learning to think, create, and collaborate in
              ways that will shape their future.
            </p>
          </div>
        </div>
      </div>

      <section className=" xl:py-12 lg:py-12 md:py-12 py-12 px-4 md:px-4 xl:px-0 lg:px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2   mx-auto xl:gap-6 lg:gap-4 gap-4">
            <div className=" justify-start">
              <div
                className="xl:py-16 xl:px-8 lg:py-16 lg:px-6 md:py-16 md:px-6 rounded-2xl py-12 px-6"
                style={{
                  background: "#f6e6e9",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "55% auto",
                }}
              >
                <img
                  src={vision}
                  alt="Vision Mission"
                  className="w-24 xl:-mt-6 lg:-mt-6 md:-mt-8"
                />
                <div className="flex gap-2 ">
                  <h3 className="text-black xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-semibold xl:pt-0 lg:pt-2 pt-2">
                    Our Vision
                  </h3>
                </div>
                <p className="xl:text-base text-base pt-4 lg:pt-4 xl:pt-4 xl:pb-8 lg:pb-4 md:pb-8">
                  At Junior Toes we nurture a new generation of entrepreneurial
                  thinkers who embrace challenges, celebrate diversity and
                  explore their own limitless possibilities to bring about a
                  better world in collaboration with all stakeholders.
                </p>
              </div>
            </div>
            <div className=" ">
              <div
                className="xl:px-8 xl:py-12 lg:py-8 lg:px-6 md:py-8 md:px-6 rounded-2xl py-8 px-6"
                style={{
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "55% auto",
                }}
              >
                <img src={mission} alt="Vision Mission" className="w-24" />
                <div className="flex gap-2 ">
                  <h3 className="text-black xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-semibold">
                    Our Mission
                  </h3>
                </div>
                <p
                  id="knowmore"
                  className="xl:text-base text-base xl:pt-4 lg:pt-2 pt-2"
                >
                  Junior Toes strives to provide a nurturing, innovative
                  learning environment that fosters creativity, collaboration,
                  and entrepreneurial thinking. By embracing diversity and
                  encouraging self-discovery, we empower children to face
                  challenges confidently. Through partnerships with families and
                  the community, Junior Toes shapes compassionate, confident
                  future leaders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="xl:block lg:block md:block sm:hidden hidden"
        style={{ background: "#f1f1f1" }}
      >
        <div className="container mx-auto xl:pt-12 lg:pt-12 lg:pb-16 xl:pb-16 md:pt-12 md:pb-4 xl:mt-6">
          <h3 className="text-black xl:text-4xl lg:text-4xl md:text-3xl text-center font-semibold">
            Our Values
          </h3>

          <div className="flex gap-4 xl:mt-6 lg:mt-6 xl:px-0 lg:px-4 md:mt-6 md:px-4">
            <div className="xl:w-4/12 lg:w-4/12 rounded-lg bg-white px-6 xl:py-6 lg:py-4 md:py-4">
              <div className="flex gap-4 justify-between items-center ">
                <div className="">
                  <p
                    className="xl:text-7xl lg:text-6xl md:text-5xl"
                    style={{ color: "#8a8989" }}
                  >
                    01
                  </p>
                </div>
                <div className="">
                  <img src={growth} alt="Vision Mission" className="w-20" />
                </div>
              </div>
              <p className="xl:text-xl lg:text-xl md:text-base text-lg xl:pt-4 lg:pt-4 pt-4">
                Growth and creativity in a caring, innovative setting.
              </p>
            </div>
            <div className="xl:w-4/12 rounded-lg bg-white px-6 xl:py-6 lg:py-4 py-4 ">
              <div className="flex gap-4 justify-between items-center">
                <div className="">
                  <p
                    className="xl:text-7xl lg:text-6xl md:text-5xl text-5xl"
                    style={{ color: "#8a8989" }}
                  >
                    02
                  </p>
                </div>
                <div className="">
                  <img src={creativity} alt="Vision Mission" className="w-20" />
                </div>
              </div>
              <p className="xl:text-xl lg:text-xl lg:pt-4 xl:pt-4 pt-4">
                Encouraging initiative, freedom and creativity.
              </p>
            </div>
            <div className="xl:w-4/12 rounded-lg bg-white px-6 xl:py-6 lg:py-4 py-4">
              <div className="flex gap-4 justify-between items-center">
                <div className="">
                  <p
                    className="xl:text-7xl lg:text-6xl md:text-5xl text-5xl"
                    style={{ color: "#8a8989" }}
                  >
                    03
                  </p>
                </div>
                <div className="">
                  <img src={individual} alt="Vision Mission" className="w-20" />
                </div>
              </div>
              <p className="xl:text-xl lg:text-xl md:text-base text-lg xl:pt-4 lg:pt-4 pt-4">
                Emphasizing resilience, inclusivity, and individuality.
              </p>
            </div>
          </div>

          <div className="flex gap-4 xl:mt-6 lg:mt-6 mx-auto justify-center mt-6 xl:px-0 lg:px-0 md:px-24 xl:pb-0 lg:p-0 md:pb-12">
            <div className="xl:w-4/12 rounded-lg bg-white px-6 xl:py-10 lg:py-4 py-4">
              <div className="flex gap-4 justify-between items-center">
                <div className="">
                  <p
                    className="xl:text-7xl lg:text-6xl md:text-5xl text-5xl"
                    style={{ color: "#8a8989" }}
                  >
                    04
                  </p>
                </div>
                <div className="">
                  <img src={relation} alt="Vision Mission" className="w-20" />
                </div>
              </div>
              <p className="xl:text-xl lg:text-xl lg:pt-4 xl:pt-4 pt-4">
                Collaboration and Partnerships.
              </p>
            </div>
            <div className="xl:w-4/12 rounded-lg bg-white px-6 xl:py-10 lg:py-4 py-4">
              <div className="flex gap-4 justify-between items-center">
                <div className="">
                  <p
                    className="xl:text-7xl lg:text-6xl md:text-5xl text-5xl"
                    style={{ color: "#8a8989" }}
                  >
                    05
                  </p>
                </div>
                <div className="">
                  <img src={leadership} alt="Vision Mission" className="w-20" />
                </div>
              </div>
              <p className="xl:text-xl lg:text-xl lg:pt-4 xl:pt-4 pt-4">
                Fostering compassionate leadership.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* mobile view */}
      <section
        className="xl:hidden lg:hidden md:hidden sm:block block px-4 pt-12 pb-12"
        style={{ background: "#f1f1f1" }}
      >
        <h3 className="text-black text-2xl text-center font-semibold">
          Our Values
        </h3>
        <div className=" rounded-lg bg-white px-6 py-4 mt-8">
          <div className="flex gap-4 justify-between items-center ">
            <div className="">
              <p className="text-5xl" style={{ color: "#8a8989" }}>
                01
              </p>
            </div>
            <div className="">
              <img src={growth} alt="Vision Mission" className="w-20" />
            </div>
          </div>
          <p className=" text-lg  pt-4">
            Growth and creativity in a caring, innovative setting.
          </p>
        </div>

        <div className=" rounded-lg bg-white px-6 py-4 mt-6">
          <div className="flex gap-4 justify-between items-center ">
            <div className="">
              <p className="text-5xl" style={{ color: "#8a8989" }}>
                02
              </p>
            </div>
            <div className="">
              <img src={creativity} alt="Vision Mission" className="w-20" />
            </div>
          </div>
          <p className=" text-lg  pt-4">
            Encouraging initiative, freedom and creativity.
          </p>
        </div>

        <div className=" rounded-lg bg-white px-6 py-4 mt-6">
          <div className="flex gap-4 justify-between items-center ">
            <div className="">
              <p className="text-5xl" style={{ color: "#8a8989" }}>
                03
              </p>
            </div>
            <div className="">
              <img src={individual} alt="Vision Mission" className="w-20" />
            </div>
          </div>
          <p className=" text-lg  pt-4">
            Emphasizing resilience, inclusivity, and individuality.
          </p>
        </div>

        <div className=" rounded-lg bg-white px-6 py-4 mt-6">
          <div className="flex gap-4 justify-between items-center ">
            <div className="">
              <p className="text-5xl" style={{ color: "#8a8989" }}>
                04
              </p>
            </div>
            <div className="">
              <img src={relation} alt="Vision Mission" className="w-20" />
            </div>
          </div>
          <p className=" text-lg  pt-4">Collaboration and Partnerships.</p>
        </div>

        <div className=" rounded-lg bg-white px-6 py-4 mt-6">
          <div className="flex gap-4 justify-between items-center ">
            <div className="">
              <p className="text-5xl" style={{ color: "#8a8989" }}>
                05
              </p>
            </div>
            <div className="">
              <img src={leadership} alt="Vision Mission" className="w-20" />
            </div>
          </div>
          <p className=" text-lg  pt-4">Fostering compassionate leadership.</p>
        </div>
      </section>

      <section className="xl:mt-20 container mx-auto parkinsans  xl:pb-16 lg:mt-20 lg:pb-16 xl:px-0 lg:px-4 md:px-4 md:mt-16 md:pb-20 mt-16 px-4 pb-16">
        <div
          className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 gap-4 
 xl:gap-4 lg:gap-4"
        >
          <div className="xl:col-span-5 lg:col-span-5 md:col-span-5 col-span-1 xl:pt-12">
            <h6 className="xl:text-lg lg:text-lg font-bold text-peach">
              Our Philosophy
            </h6>
            <h2 className="text-black xl:text-4xl lg:text-4xl md:text-3xl text-2xl pt-2 xl:pt-2 lg:pt-2 font-semibold">
              The first five years build the foundation of a lifetime— let’s
              make those years extraordinary
            </h2>
            <p className="xl:pt-2 lg:pt-2 pt-2 md:text-base lg:text-base xl:text-base text-justify xl:w-12/12 lg:w-12/12">
              At Junior Toes, our philosophy is deeply rooted in understanding
              the critical brain development that takes place in the first five
              years. During this period, a child’s brain forms over a million
              neural connections every second, shaping their cognitive, social,
              and emotional abilities for life. Our playful and entrepreneurial
              approach taps into this natural window of growth, stimulating
              creativity, problemsolving, and emotional resilience. By providing
              enriching experiences in a nurturing environment, we help build
              strong neural pathways, setting the stage for lifelong learning
              and adaptability.
            </p>
          </div>

          <div
            className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1
 xl:pl-12 xl:mt-0 lg:mt-0 md:mt-0 mt-6"
          >
            <div className="flex justify-end ">
              <img
                className="xl:w-11/12 lg:w-12/12 md:w-12/12 w-12/12 rounded-lg xl:-ml-2 xl:h-0 lg:h-0 md:h-480  "
                src={aboutkid}
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mx-auto">
          <div className="xl:w-10/12  mx-auto text-center ">
            <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-bold text-black pt-2">
              Frequently Asked Questions
            </h2>
            <p
              className="xl:text-xl text-xl mt-2 xl:mt-3"
              style={{ lineHeight: 1.9 }}
            >
              What would you like to know?
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white  xl:pb-20 lg:pb-16  md:pb-12  pb-16 parkinsans xl:px-0 lg:px-4 md:px-4  px-2">
        <div className="container mx-auto ">
          <div className="flex mx-auto justify-center xl:gap-6 gap-4">
            <div className="xl:w-9/12 lg:w-7/12 md:w-11/12 w-12/12">
              {/* question 1 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 p-4  cursor-pointer xl:mt-12 lg:mt-8 mt-8"
                onClick={() => toggleAccordion(1)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What age group does Junior Toes cater to?
                    </h1>
                  </div>
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What age group does Junior<br></br> Toes cater to?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 1 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 1 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Junior Toes is designed for children aged 2 to 6 years,
                      offering age appropriate programmes to nurture their
                      growth and develop
                    </p>
                  </div>
                )}
              </div>

              {/* question 2 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 p-4 mt-4 xl:mt-4"
                onClick={() => toggleAccordion(2)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What makes Junior Toes different from other preschools?
                    </h1>
                  </div>
                  {/* mobileview */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className=" text-base font-semibold text-black">
                      What makes Junior Toes different<br></br> from other
                      preschools?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 2 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 2 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Junior Toes focuses on developing entrepreneurial skills
                      like leadership, teamwork, and problem-solving through
                      play-based, experiential learning. We also emphasize
                      environmental awareness and encourage critical thinking
                      through our Technology of consciousness (TOC) and Modality
                      of Consciousness (MOC) approach.
                    </p>
                  </div>
                )}
              </div>

              {/* question 3 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(3)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the teacher-to-child ratio?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 3 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 3 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      We maintain a low teacher-to-child ratio to ensure
                      personalized attention and support for each child’s
                      individual learning needs.
                    </p>
                  </div>
                )}
              </div>

              {/* question 4 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 mt-4 p-4"
                onClick={() => toggleAccordion(4)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What curriculum does Junior Toes follow?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 4 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 4 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Our curriculum and pedagogy partner is with a team of
                      International and National Curriculum designed by Award Winning Educationists who have
                      developed the Antah:Prerana way of learning. Antah:Prerana
                      way of learning blends international best practices in
                      early childhood education with entrepreneurial principles,
                      focusing on holistic development through various themes.
                    </p>
                  </div>
                )}
              </div>

              {/* question 5 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(5)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How are children prepared for primary school after Junior
                      Toes?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className=" text-base font-semibold text-black">
                      How are children prepared for primary<br></br> school
                      after Junior Toes?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 5 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 5 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4 ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Junior Toes builds a strong foundation in academics,
                      social skills, and emotional resilience, ensuring a smooth
                      transition to primary school while fostering a love for
                      learning and independent thinking
                    </p>
                  </div>
                )}
              </div>

              {/* question 6 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(6)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      What safety and hygiene measures are in place?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      What safety and hygiene<br></br> measures are in place?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 6 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 6 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Safety is our top priority. Our campus is child-proofed,
                      equipped with CCTV surveillance, and maintained with
                      strict hygiene protocols. Facilitators are trained in
                      first aid and emergency handling.
                    </p>
                  </div>
                )}
              </div>

              {/* question 7 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(7)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the daily schedule like?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 7 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 7 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4 ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      The day is structured to balance learning, play, rest, and
                      meals. Activities include group sessions, outdoor play,
                      storytelling, creative workshops, and exploration time.
                    </p>
                  </div>
                )}
              </div>

              {/* question 8 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(8)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How do you handle separation anxiety?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 8 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 8 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      We follow a gradual settling-in process to make children
                      feel comfortable. Our facilitators provide personalized
                      attention and work closely with parents to ensure a smooth
                      transition.
                    </p>
                  </div>
                )}
              </div>

              {/* question 9 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(9)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      Are meals provided, and what is the menu like?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className=" text-base font-semibold text-black ">
                      Are meals provided, and what <br></br>is the menu like?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 9 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 9 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Yes, we provide nutritious, well-balanced meals that are
                      child friendly and cater to dietary preferences or
                      allergies. Parents are welcome to review the menu
                    </p>
                  </div>
                )}
              </div>

              {/* question 10*/}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(10)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      How are parents involved in the learning process?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="text-base font-semibold text-black ">
                      How are parents involved in<br></br> the learning process?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 10 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 10 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      We believe in a strong home-school partnership. Parents
                      are updated regularly through newsletters, parent-teacher
                      meetings, and interactive workshops to stay involved in
                      their child’s progress.
                    </p>
                  </div>
                )}
              </div>

              {/* question 11 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(11)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      Do you offer transportation?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 11 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 11 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      Yes, we provide safe and reliable transportation services
                      with trained staff to ensure your child’s safety during
                      transit.
                    </p>
                  </div>
                )}
              </div>

              {/* question 12 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(12)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What documents are required for admission?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What documents are required<br></br> for admission?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 12 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 12 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      You will need to submit a copy of your child’s birth
                      certificate, medical records, and recent photographs.
                      Additional documents may be requested during the admission
                      process which can be seen in the apply for admission page
                    </p>
                  </div>
                )}
              </div>

              {/* question 13 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(13)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the fee structure, and are there any additional
                      costs?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the fee structure, and<br></br> are there any
                      additional costs?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 13 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 13 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Our fee structure is competitive and includes tuition,
                      meals, and basic supplies. Any additional costs, such as
                      excursions or special events, will be communicated well in
                      advance.
                    </p>
                  </div>
                )}
              </div>

              {/* question 14 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(14)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How do you ensure equal attention to all children?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How do you ensure equal attention<br></br> to all
                      children?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 14 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 14 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      With a low teacher-to-child ratio and activity-based
                      learning, every child receives individualized attention
                      and support in our inclusive environment.
                    </p>
                  </div>
                )}
              </div>

              {/* question 15 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(15)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How can I track my child’s progress
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 15 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 15 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      We provide regular progress reports and conduct
                      parent-teacher meetings. Additionally, our facilitators
                      are always available to discuss your child’s development.
                    </p>
                  </div>
                )}
              </div>

              {/* question 16 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(16)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What happens if my child falls sick during school hours?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What happens if my child falls<br></br> sick during school
                      hours?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 16 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 16 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      If a child feels unwell, our facilitators provide
                      immediate care and inform the parents promptly. We have a
                      first-aid-trained team and a doctor on call for
                      emergencies.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </>
  );
}
